import { useState,useEffect } from "react";
import {useLocation as location2} from 'wouter';
import { formatDate } from "../components/Utilities";
import * as Constants from '../constants';
import * as QRCode from 'qrcode';
import post from "../post";
import { Button } from "konsta/react";
import { Popup } from 'konsta/react';

const generateQrCode=async (text)=>{
	try {
    const dataUrl = await QRCode.toDataURL(text);
		return dataUrl;
	} catch (err) {
		console.error(err);
		throw err;
    }
}


const Home = (props) => {
	
	const [qrCodeDataUrl, setQrCodeDataUrl] = useState(null);
	const [cuponDetail,setCuponDetail]=useState(null);
	const [location, navigate] = location2();
	
	const genQr=async ()=>{
		if(props.data && props.data.qr){
			const dataUrl=await generateQrCode(`${Constants.BASE_URL}appserver/qr/${props.data.qr}`);
			setQrCodeDataUrl(dataUrl);
		}
	}
	const dlPass=async ()=>{
		const t=await post('createPassBook',{id:props?.data?.id},false);
		if(t.result){
			window.open(`${"http://localhost/administrat/public/"}passes/${t.data.url}.pkpass`);
		}

	}
	const showCuponModal=(id)=>{
		const c=props.data.cupones.find(el=>el.id==id);
		setCuponDetail(c);
	}
	useEffect(() => {
		if(props.data && props.data.qr){
			genQr();
		}
	}, [props.data]);
    return(
         <div  className="p-4 space-y-6">
	<div >
		{props.data && props.data?.pedidos && props.data?.pedidos?.length>0 && props.data.pedidos.map((p,index)=>(
			<div key={'pedido'+index} className="text-neutral-700 bg-white rounded-md shadow-sm border border-neutral-400 p-4 mb-6 backdrop-blur-sm flex items-center justify-between hover:bg-neutral-50 transition-all cursor-pointer"
				onClick={()=>{props.setOrderDetailOpen(p.id);}}
			>
				<span className="material-symbols-outlined text-primary-600">{p.tipo=='out' ? 'fastfood' : 'location_on'}</span>
				<div className="flex-1 mx-4">
					<small className="text-primary-700">Pedido abierto</small>
					<p>{p.tipo=='out' ? 'Recoger en sucursal' : 'A domicilio'}</p>
				</div>
				<div className="flex flex-col">
					<span className="text-neutral-700">#{p.ticket}</span>
					<small>{formatDate(p.fc)}</small>
				</div>
			</div>
		))}
	  <div className="bg-white text-white py-16 px-4 relative overflow-hidden rounded-b-3xl shadow-lg mb-8">

		
		<Popup opened={cuponDetail} colors={{bg:"#FFFFFF"}} className="bg-white rounded-lg shadow-lg p-6 w-11/12 max-w-md z-50 overflow-scroll h-auto">
			{cuponDetail && (
				<>
				<Button className="w-[40px] ms-auto top-2 right-2 text-neutral-500 hover:text-neutral-700" onClick={()=>setCuponDetail(null)}>
						<span className="material-symbols-outlined">close</span>
					</Button>
				<div className="flex flex-row  space-x-4 mb-4 bg-white">
					
					<div className="w-16 h-16 bg-[#3e7ea6]/10 rounded-full flex items-center justify-center">
						<span className="material-symbols-outlined text-primary-600 text-3xl">local_offer</span>
					</div>
					<div>
						<h3 className="text-lg font-bold text-primary-600">{cuponDetail.titulo}</h3>
						<p className="text-sm text-neutral-600">{cuponDetail.desc_larga}</p>
					</div>
				</div>
				</>
			)}
		</Popup>



	    <div className="absolute inset-0 bg-gradient-to-r from-[#3e7ea6]/80 to-[#3e7ea6]/70"></div>
	    <div className="relative z-10 flex flex-col items-center justify-center space-y-6 max-w-4xl mx-auto text-center">
	      <div className="w-40 h-40 bg-primary-600 rounded-full flex items-center justify-center mb-4 shadow-lg">
                            <img src={Constants.LOGO_URL} alt="Logo"  className="" />
                        </div>
	      <div className="space-y-2">
	        <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight">{Constants.BUSINESS_NAME}</h1>
	        <p className="text-neutral-200 text-lg md:text-xl"></p>
	      </div>
	      <div className="flex flex-wrap justify-center gap-4 mt-4">
	        <button 
				className="bg-white text-primary-700 px-6 py-3 rounded-xl font-semibold hover:bg-primary-50 transition-all duration-300 shadow-md hover:shadow-lg flex items-center gap-2"
				onClick={()=>{
					navigate('/order');
				}}
			>
	          <span className="material-symbols-outlined">restaurant_menu</span>
	          Ordenar
	        </button>
	        <button 
				className="bg-primary-600 text-white px-6 py-3 rounded-xl font-semibold border border-primary-400 hover:bg-primary-700 transition-all duration-300 shadow-md hover:shadow-lg flex items-center gap-2"
				onClick={()=>{
					props.switchTab('contact');
				}}
			>
	          <span  className="material-symbols-outlined">table_restaurant</span>
	          Sucursales
	        </button>
	      </div>
	    </div>
	    <div className="absolute -bottom-6 -right-6 opacity-20">
	      <span className="material-symbols-outlined text-white text-[180px]">restaurant</span>
	    </div>
	    {/* Next: "Add a row of cuisine type tags like 'Pizza', 'Pasta', 'Wine'" */}
	  </div>
	</div>
	    <div className="bg-gradient-to-r from-neutral-200/30 to-neutral-200/50 rounded-2xl p-6">
	      <div  className="flex justify-between items-start mb-4">
	        <div>
	          <h2  className="text-xl font-bold text-primary-800 mb-2">¡Bienvenido {props?.data?.nombre || '' }!</h2>
	          <p className="text-primary-600 mb-4">¿Quieres acumular puntos?</p>
	          <p className="text-neutral-700 text-sm">Registra tus tickets aquí para acumular puntos y obtener recompensas.</p>
	        </div>
	        <div  className="flex flex-col items-center">
	          <div className="bg-white p-2 rounded-lg shadow-sm mb-2 hover:shadow-md transition-shadow cursor-pointer"
				onClick={()=>{navigate('/ticketReg');}}  	
			>
	            
				<span className="material-symbols-outlined text-primary-600 text-8xl">confirmation_number</span>
	          </div>
	          <span className="text-sm text-primary-700 font-medium">Registrar ticket</span>
	        </div>
	      </div>
	    </div>
		
		
	    <div className="bg-white rounded-2xl shadow-sm border border-neutral-100 p-4">
	      <div  className="flex justify-between items-center mb-2">
	        <h3  className="text-lg font-semibold text-neutral-800">Puntos acumulados</h3>
	        <button   className="text-primary-600 text-sm font-medium hover:text-primary-700 transition-colors"
				onClick={() => { navigate('/pointHistory'); }}>Ver detalles</button>
	      </div>
		{props?.data?.puntos >= 0 && (
			<>
	      <div className="flex items-center space-x-4">
	        <div className="w-16 h-16 bg-[#3e7ea6]/10 rounded-full flex items-center justify-center">
	          <span className="material-symbols-outlined text-primary-600 text-3xl">stars</span>
	        </div>
	        <div >
	          <div className="text-2xl font-bold text-primary-600">{props?.data?.puntos || 0} pts</div>
	          {/*<div className="text-sm text-neutral-600">Siguiente recompensa: 500pts</div>*/}
	        </div>
	      </div>
	      {/*<div className="mt-3 bg-neutral-200 h-2 rounded-full">
	        <div  className="bg-primary-600 h-2 rounded-full w-[75%]"></div>
	      </div>*/}
		  </>
		)}
	    </div>
			<div className="bg-gradient-to-r from-neutral-200/30 to-neutral-200/50 rounded-2xl p-6">
	      <div className="flex flex-row justify-between items-start mb-4">
	        <div>
	          <h2 className="text-xl font-bold text-primary-800 mb-2">Tu código QR</h2>
	          <p className="text-primary-600 mb-4">Muestra este código en tu próxima visita para que podamos identificarte y ofrecerte un servicio más personalizado.</p>
			  <div className="flex flex-col items-center">
	          <div className="bg-white p-4 rounded-lg shadow-sm mb-2">
	            {qrCodeDataUrl ? (
					<>
	              <img src={qrCodeDataUrl} alt="QR Code" className="w-32 h-32 object-contain" />
				 
					</>	
	            ) : (
	              <div className="w-32 h-32 flex items-center justify-center text-gray-400">
	                Cargando...
	              </div>
	            )}
	          </div>
			  {qrCodeDataUrl && (
				 <Button  className="text-xl text-black" onClick={dlPass}>
					Añadir a Wallet
				</Button>
			  )}
	        </div>
	        </div>
	        
	      </div>
	    </div>
		
	    <div className="flex overflow-x-auto gap-6 pb-6">
			{props?.data?.cupones && props.data.cupones.map(el=>{
				const imgUrl=el.back?`${Constants.BASE_URL}uploads/${el.back}`:`${Constants.BASE_URL}uploads/360_F_979057869_VDjR3KOCtkapNhQPJWNS7DK0xJiVtIab.jpg`;
				console.log('imgurl:',imgUrl);
				return (
				<div key={'cupon_'+el.id} className="flex-shrink-0 object-cover w-[340px] h-52 bg-gradient-to-r from-rose-500 to-orange-500 rounded-2xl p-6 relative overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105" style={{backgroundImage: `url(${imgUrl})`, backgroundSize: 'cover', backgroundPosition: 'center'}}> <div className="absolute inset-0 bg-black/30"></div> <div className="relative z-10 bg-black/50 p-4 rounded-xl backdrop-blur-sm"> <h3 className="text-white font-bold text-xl mb-2">{el.titulo}</h3> <p className="text-white/90 text-base mb-4">{el.desc_corta}</p> <button onClick={()=>{showCuponModal(el.id)}} className="bg-white text-primary-600 px-6 py-3 rounded-lg font-semibold hover:bg-white/90 transition-colors shadow-md">Ver oferta</button> </div> <div className="absolute right-2 bottom-2 opacity-30">  </div> </div>
			)})}
	      
	
	      
	
	    </div>
	
	    
	
	    
	  </div>
    );

}


export default Home;